import { Button, css, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { device } from 'src/constants/mediaQueries';

export function ReturnToProductLibraryButton() {
  const { t } = useTranslation('manageProduct');
  return (
    <ReturnButtonContainer>
      <ReturnButton
        data-testid="return-to-library-button"
        href="/product-library"
        variant="contained"
        color="secondary"
      >
        {t('template.returnToLibraryButton')}
      </ReturnButton>
    </ReturnButtonContainer>
  );
}

export const ReturnButtonContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
  padding-right: 50px;
`;

export const ReturnButton = styled(Button)`
  ${({ theme }) => css`
    font-size: ${theme.typography.body1.fontSize};
    color: white;
    margin: 10px;
    @media only screen and ${device.mobileOrTablet} {
      font-size: ${theme.typography.body2.fontSize};
    }
  `};
  text-transform: unset;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.light};
  }
  .MuiButton-startIcon {
    margin-right: 1rem;
  }
`;
